const resolvers = require('./resolvers');
const LOGIN_STATE = require('./login-state');

module.exports = { LOGIN_STATE, resolvers };
